import { useEffect } from 'react';

import { useRecoilState } from 'recoil';
import { DialogState } from 'inpock-ui-react';

import { dialogState, initialDialogState } from '@/store';

type DialogSetting = Omit<DialogState, 'visible'>;

export function useDialog(): [
  (dialogSetting: DialogSetting) => void,
  () => void,
  () => void,
  () => void,
] {
  const [dialog, setDialog] = useRecoilState(dialogState);

  useEffect(() => {
    return () => setDialog(initialDialogState);
  }, [setDialog]);

  const dialogOff = () => {
    setDialog(initialDialogState);
  };

  const dialogOn = (dialogSetting: DialogSetting) => {
    dialogOff();
    const newClose = {
      ...initialDialogState.close,
      ...dialogSetting.close,
    };
    const newConfirm = dialogSetting.confirm && {
      ...initialDialogState.confirm,
      ...dialogSetting.confirm,
    };
    setTimeout(() => {
      setDialog({
        visible: true,
        template: dialogSetting.template,
        close: newClose,
        confirm: newConfirm,
      });
    }, 0);
  };

  const loadingOn = () => {
    setDialog((currVal) => {
      const newClose = {
        ...currVal.close,
        loading: true,
      };
      const newConfirm = currVal.confirm && {
        ...currVal.confirm,
        loading: true,
      };

      return {
        ...currVal,
        close: newClose,
        confirm: newConfirm,
      };
    });
  };

  const loadingOff = () => {
    setDialog((currVal) => {
      const newClose = {
        ...currVal.close,
        loading: false,
      };
      const newConfirm = currVal.confirm && {
        ...currVal.confirm,
        loading: false,
      };

      return {
        ...currVal,
        close: newClose,
        confirm: newConfirm,
      };
    });
  };

  return [dialogOn, dialogOff, loadingOn, loadingOff];
}
